import { render, staticRenderFns } from "./Marketing.html?vue&type=template&id=8f11ca46&external"
import script from "./Marketing.js?vue&type=script&lang=js&external"
export * from "./Marketing.js?vue&type=script&lang=js&external"
import style0 from "./Marketing.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports